<template>
    <modal-ui
        :id="id"
        size="modal-sm"
        :title="state.mode === 'update' ? $t('humans.updateDahuaFace') : $t('humans.sendToDahua')">
        <form class="loader" @submit.prevent="send">
            <loader-ui :is-show="state.loader" />

            <div class="mb-3">
                <label class="form-label w-100">
                    {{ $t('humans.dahuaPhoto') }}
                    <br><small class="text-danger"><strong>Максимальный размер файла: 2MB</strong></small>
                </label>
                <input
                    class="form-control"
                    type="file"
                    accept="image/*"
                    @change="onFileSelected"
                >
                <div v-if="state.error" class="text-danger mt-2">
                    {{ state.error }}
                </div>
            </div>

            <div v-if="state.preview" class="mb-3">
                <img :src="state.preview" class="w-100 border rounded" alt="preview">
            </div>

            <div class="text-center">
                <button-ui button-class="btn-primary" :disabled="!state.preview || state.loader">
                    {{ state.mode === 'update' ? $t('humans.updateDahuaFace') : $t('humans.sendToDahua') }}
                </button-ui>
            </div>
        </form>
    </modal-ui>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive } from "vue";
import { useModal } from "@/composables/useModal";
import api from "@/api";

export default defineComponent({
    name: "DahuaFaceModal",
    props: {
        id: {
            type: String,
            default: '',
        },
    },
    setup(props) {
        const modal = useModal(props.id);

        const MAX_FILE_BYTES = 2 * 1024 * 1024;

        const state = reactive({
            mode: 'add' as 'add' | 'update',
            humanId: 0,
            loader: false,
            preview: '' as string,
            fileSize: 0,
            error: '' as string,
        });

        function validateFileSize(size: number): string {
            if (size > MAX_FILE_BYTES) {
                return `Размер файла превышает 2MB. Текущий размер: ${(size / (1024 * 1024)).toFixed(2)}MB`;
            }
            return '';
        }

        onMounted(() => {
            state.mode = modal.data.mode || 'add';
            state.humanId = Number(modal.data.humanId || 0);
        });

        function onFileSelected(e: Event) {
            state.error = '';
            const input = e.target as HTMLInputElement;
            const file = input.files?.[0];
            if (!file) {
                state.preview = '';
                state.fileSize = 0;
                return;
            }

            const sizeError = validateFileSize(file.size);
            if (sizeError) {
                state.error = sizeError;
                state.preview = '';
                state.fileSize = 0;
                input.value = '';
                return;
            }

            state.fileSize = file.size;

            const reader = new FileReader();
            reader.onload = () => {
                state.preview = String(reader.result || '');
            };
            reader.onerror = () => {
                state.error = 'Не удалось прочитать файл';
                state.preview = '';
            };
            reader.readAsDataURL(file);
        }

        async function send() {
            if (!state.humanId) {
                state.error = 'Не задан humanId';
                return;
            }
            if (!state.preview) {
                state.error = 'Выберите изображение';
                return;
            }

            const sizeError = validateFileSize(state.fileSize);
            if (sizeError) {
                state.error = sizeError;
                return;
            }

            state.loader = true;
            state.error = '';
            try {
                const r: any = await api.v1.humans.dahuaSync(state.humanId, state.preview);
                modal.ok({
                    human: r?.data?.data?.human || null,
                    raw: r?.data,
                });
            } catch (e: any) {
                state.error = e?.response?.data?.message || 'Ошибка отправки';
            } finally {
                state.loader = false;
            }
        }

        return {
            state,
            onFileSelected,
            send,
        };
    },
});
</script>

<style scoped lang="scss">
</style>
